module.exports = __webpack_public_path__ + "assets/chocobo.88cc5c9a.png";